// extracted by mini-css-extract-plugin
export default {"container":"ProBadge_container__byIIm","star":"ProBadge_star__kpOm7"};